import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('trxl_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('trxl_cookie_consent', 'accepted');
    localStorage.setItem('trxl_cookie_date', new Date().toISOString());
    setVisible(false);
    // Trigger first analytics page-view now that consent is granted
    try {
      const ev = new Event('trxl-consent-granted');
      window.dispatchEvent(ev);
    } catch {}
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted', ad_storage: 'granted' });
    }
  };

  const handleDecline = () => {
    localStorage.setItem('trxl_cookie_consent', 'declined');
    localStorage.setItem('trxl_cookie_date', new Date().toISOString());
    setVisible(false);
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'denied', ad_storage: 'denied' });
    }
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent-banner" style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: 'rgba(10,10,10,0.98)', borderTop: '1px solid rgba(255,255,255,0.1)',
      backdropFilter: 'blur(20px)', padding: '1.25rem 1.5rem',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
        <Shield size={20} style={{ color: '#FF2E2E', flexShrink: 0 }} />
        <p style={{ flex: 1, color: 'rgba(255,255,255,0.75)', fontSize: '0.85rem', lineHeight: 1.6, margin: 0, minWidth: '250px' }}>
          Wir respektieren Ihre Privatsphäre. Diese Website verwendet Cookies, um Ihnen das bestmögliche Einkaufserlebnis zu bieten.
          Sie können Ihre Auswahl jederzeit auf der Seite{' '}
          <Link to="/cookie-richtlinie" style={{ color: '#FF2E2E', textDecoration: 'underline' }}>Cookie-Richtlinie</Link> ändern.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', flexShrink: 0 }}>
          <button onClick={handleDecline} data-testid="cookie-decline-btn" style={{
            padding: '0.6rem 1.25rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)',
            color: 'rgba(255,255,255,0.7)', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
            textTransform: 'uppercase', letterSpacing: '0.05em', transition: 'all 0.2s',
          }}>Ablehnen</button>
          <button onClick={handleAccept} data-testid="cookie-accept-btn" style={{
            padding: '0.6rem 1.25rem', background: '#FF2E2E', border: '1px solid #FF2E2E',
            color: '#fff', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
            textTransform: 'uppercase', letterSpacing: '0.05em', transition: 'all 0.2s',
          }}>Akzeptieren</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
